import React from 'react';
import { LocationPage } from './useLocationPage';
import './useLocationPage.css';

// ─── Images ───────────────────────────────────────────────────────────────────
// Swap out any of these for Sarasota-specific shots
import heroImg   from '../images/tampa3.webp';
import bgImg     from '../images/image8.webp';
import slideImg1 from '../images/image121.webp';
import slideImg2 from '../images/image117.webp';
import slideImg3 from '../images/image50.webp';

// ─── Config ───────────────────────────────────────────────────────────────────
const southPasadenaConfig = {

  /* ── SEO ────────────────────────────────────────────────────────────────── */
  pageTitle:       'South Pasadena Tree Service | Sam\'s Tree Service',
  metaDescription: 'Expert tree trimming and removal in South Pasadena, FL. Sam\'s Tree Service handles dangerous trees safely and professionally.',
  canonicalUrl:    'https://samstreeservice.com/tree_service_south_pasadena',

  /* ── Hero ───────────────────────────────────────────────────────────────── */
  heroHeading: 'Serving South Pasadena',
  heroImageUrl: heroImg,
  bgImageUrl:   bgImg,

  /* ── Slide images ───────────────────────────────────────────────────────── */
  slideImage1: slideImg1,
  slideImage2: slideImg2,
  slideImage3: slideImg3,

  /* ── Main text panel ────────────────────────────────────────────────────── */
  sectionHeading: 'Professional Tree Service in South Pasadena Specializing In Dangerous Trees',

  paragraphs: [
    `At <strong>Sam's Tree Service</strong>, we provide professional tree care to the 
     residential properties and waterfront homes of <strong>South Pasadena</strong>. 
     Nestled between Boca Ciega Bay and the Gulf beaches, this community deals with 
     the same coastal stressors that age trees fast salt air, tidal winds, and tropical 
     storms that leave behind damaged limbs and leaning trunks threatening nearby 
     structures.`,

    `We specialize in <strong>dangerous tree situations on coastal and waterfront 
     properties</strong> overhanging limbs near seawalls and docks, storm compromised 
     palms, heavily overgrown canopies, and trees with root instability from salt saturated 
     soil. We work carefully on tight lots and leave every property clean.`,

    `<strong>Sam's Tree Service</strong> delivers dependable, affordable tree care 
     throughout <strong>South Pasadena</strong> and across <strong>South Pinellas 
     County</strong> protecting your home and keeping your landscape in top shape 
     through every season.`,
  ],
  ctaLabel: 'Get a Free Estimate!',

  /* ── Service buttons (optional — defaults to the 4 standard ones) ────────── */
  // serviceButtons: [
  //   { label: 'Tree Trimming', to: '/tree_trimming' },
  //   { label: 'Tree Removal',  to: '/tree_removal'  },
  //   { label: 'Stump Removal', to: '/stump_removal'  },
  //   { label: 'Debris Hauling',to: '/debris_hauling' },
  // ],

  /* ── Google Map ─────────────────────────────────────────────────────────── */
  mapCity: 'South Pasadena, FL',
};

// ─── Page ─────────────────────────────────────────────────────────────────────
const Services_SouthPasadena = () => <LocationPage config={southPasadenaConfig} />;
export default Services_SouthPasadena;
